export default __webpack_public_path__ + "static/media/invoice.98a90577.PNG";